// src/components/admin/tabs/OverviewTab.js
import React, { useContext, useState, useEffect } from "react";
import { Card, Row, Col, Table } from "react-bootstrap";
import { UserContext } from "../../../contexts/UserContext";

import api from "../../../axiosConfig";

const OverviewTab = () => {
  const { maintenanceHistory, machines, loading } = useContext(UserContext);
  const [categoryData, setCategoryData] = useState([]);
  const [dailyData, setDailyData] = useState([]);
  const percent = (value, total) => {
    if (!total || total === 0) return "0%";
    return `${((value / total) * 100).toFixed(1)}%`;
  };

  const [machineStats, setMachineStats] = useState({
    total: 0,
    underMaintenance: 0,
    pending: 0,
  });
  const [tools, setTools] = useState([]);
  const [toolStats, setToolStats] = useState({
    total: 0,
    underMaintenance: 0,
    pending: 0,
    ng: 0,
    normal: 0,
  });

  useEffect(() => {
    const fetchTools = async () => {
      try {
        const res = await api.get("/maintenance/tools/list");
        setTools(res.data || []);
      } catch (err) {
        console.error("Gagal ambil tools:", err);
      }
    };

    fetchTools();
  }, []);

  useEffect(() => {
    if (!tools) return;

    const total = tools.length;

    const pendingCount = tools.filter(
      (t) => t.tool_status === "BUTUH_DIPERBAIKI",
    ).length;

    const underMaintenanceCount = tools.filter(
      (t) => t.tool_status === "SEDANG_DIPERBAIKI",
    ).length;

    const ngCount = tools.filter((t) => t.tool_status === "NG").length;

    const normalCount = tools.filter((t) => t.tool_status === "OK").length;

    setToolStats({
      total,
      underMaintenance: underMaintenanceCount,
      pending: pendingCount,
      ng: ngCount,
      normal: normalCount,
    });
  }, [tools]);

  useEffect(() => {
    if (!machines) return;

    const sedangDiperbaiki = machines.filter(
      (m) => m.status === "Under Maintenance",
    ).length;

    const menungguPerbaikan = machines.filter(
      (m) => m.status === "Need Maintenance",
    ).length;

    const totalMesin = machines.length;

    setCategoryData([
      { category: "Total Mesin", count: totalMesin, color: "#198754" },
      {
        category: "Sedang Diperbaiki",
        count: sedangDiperbaiki,
        color: "#FFC107",
      },
      {
        category: "Menunggu Perbaikan",
        count: menungguPerbaikan,
        color: "#DC3545",
      },
    ]);
  }, [machines]);

  useEffect(() => {
    const total = machines?.length || 0;

    const underMaintenanceCount =
      machines?.filter((machine) => machine.status === "Under Maintenance")
        .length || 0;

    const pendingCount =
      machines?.filter((machine) => machine.status === "Need Maintenance")
        .length || 0;

    setMachineStats({
      total,
      underMaintenance: underMaintenanceCount,
      pending: pendingCount,
    });
  }, [machines]);

  const statusBoxStyle = {
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "4px",
    padding: "35px",
  };

  if (loading) return <div>Memuat data...</div>;

  return (
    <div className="p-3">
      <Row className="g-2 equal-height-row">
        {/* KOTAK 1: Statistik Mesin */}
        <Col xs={12} md={6} style={{ height: "98%" }}>
          <Card>
            <Card.Header
              className="text-center"
              style={{ background: "#1e3a8a", color: "#fff" }}
            >
              Status Mesin
            </Card.Header>
            <Card.Body>
              <Row className="g-3">
                {[
                  machineStats.total,
                  machineStats.underMaintenance,
                  machineStats.pending,
                ].map((val, idx) => {
                  const labels = [
                    "Total Mesin",
                    "Sedang Diperbaiki",
                    "Menunggu Perbaikan",
                  ];
                  const colors = ["bg-success", "bg-warning", "bg-danger"];
                  return (
                    <Col xs={12} sm={4} key={idx}>
                      <div
                        className={`text-center text-dark mb-2 ${colors[idx]}`}
                        style={statusBoxStyle}
                      >
                        <h2>{val}</h2>
                        <p className="mb-0">{labels[idx]}</p>
                      </div>
                    </Col>
                  );
                })}
              </Row>

              <Table striped bordered hover responsive className="mt-3">
                <thead>
                  <tr className="text-center">
                    <th style={{ background: "#1e3a8a", color: "#fff" }}>
                      STATUS
                    </th>
                    <th style={{ background: "#1e3a8a", color: "#fff" }}>
                      JUMLAH
                    </th>
                    <th style={{ background: "#1e3a8a", color: "#fff" }}>
                      PERSENTASE
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="fw-bold">
                    <td>Total</td>
                    <td className="text-center">{machineStats.total}</td>
                    <td className="text-center">100%</td>
                  </tr>
                  <tr>
                    <td>Sedang Diperbaiki</td>
                    <td className="text-center">
                      {machineStats.underMaintenance}
                    </td>
                    <td className="text-center">
                      {machineStats.total > 0
                        ? `${((machineStats.underMaintenance / machineStats.total) * 100).toFixed(1)}%`
                        : "0%"}
                    </td>
                  </tr>
                  <tr>
                    <td>Menunggu Perbaikan</td>
                    <td className="text-center">{machineStats.pending}</td>
                    <td className="text-center">
                      {machineStats.total > 0
                        ? `${((machineStats.pending / machineStats.total) * 100).toFixed(1)}%`
                        : "0%"}
                    </td>
                  </tr>
                  <tr>
                    <td>Beroperasi Normal</td>
                    <td className="text-center">
                      {machineStats.total -
                        machineStats.underMaintenance -
                        machineStats.pending}
                    </td>
                    <td className="text-center">
                      {machineStats.total > 0
                        ? `${(((machineStats.total - machineStats.underMaintenance - machineStats.pending) / machineStats.total) * 100).toFixed(1)}%`
                        : "0%"}
                    </td>
                  </tr>
                </tbody>
              </Table>
            </Card.Body>
          </Card>
        </Col>
        <Col xs={12} md={6} style={{ height: "100%" }}>
          <Card>
            <Card.Header
              className="text-center"
              style={{ background: "#1e3a8a", color: "#fff" }}
            >
              Status Tools
            </Card.Header>
            <Card.Body>
              <Row className="g-3">
                {[
                  toolStats.total,
                  toolStats.underMaintenance,
                  toolStats.pending,
                ].map((val, idx) => {
                  const labels = [
                    "Total Tools",
                    "Sedang Diperbaiki",
                    "Menunggu Perbaikan",
                  ];
                  const colors = ["bg-success", "bg-warning", "bg-danger"];
                  return (
                    <Col xs={12} sm={4} key={idx}>
                      <div
                        className={`text-center text-dark mb-2 ${colors[idx]}`}
                        style={statusBoxStyle}
                      >
                        <h2>{val}</h2>
                        <p className="mb-0">{labels[idx]}</p>
                      </div>
                    </Col>
                  );
                })}
              </Row>

              <Table striped bordered hover responsive className="mt-3">
                <thead>
                  <tr className="text-center">
                    <th style={{ background: "#1e3a8a", color: "#fff" }}>
                      STATUS
                    </th>
                    <th style={{ background: "#1e3a8a", color: "#fff" }}>
                      JUMLAH
                    </th>
                    <th style={{ background: "#1e3a8a", color: "#fff" }}>
                      PERSENTASE
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="fw-bold">
                    <td>Total</td>
                    <td className="text-center">{toolStats.total}</td>
                    <td className="text-center">100%</td>
                  </tr>
                  <tr>
                    <td>Sedang Diperbaiki</td>
                    <td className="text-center">
                      {toolStats.underMaintenance}
                    </td>
                    <td className="text-center">
                      {percent(toolStats.underMaintenance, toolStats.total)}
                    </td>
                  </tr>

                  <tr>
                    <td>Menunggu Perbaikan</td>
                    <td className="text-center">{toolStats.pending}</td>
                    <td className="text-center">
                      {percent(toolStats.pending, toolStats.total)}
                    </td>
                  </tr>

                  <tr>
                    <td>NG</td>
                    <td className="text-center">{toolStats.ng}</td>
                    <td className="text-center">
                      {percent(toolStats.ng, toolStats.total)}
                    </td>
                  </tr>

                  <tr>
                    <td>Beroperasi Normal</td>
                    <td className="text-center">{toolStats.normal}</td>
                    <td className="text-center">
                      {percent(toolStats.normal, toolStats.total)}
                    </td>
                  </tr>
                </tbody>
              </Table>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* CSS untuk responsive */}
      <style>{`
        .equal-height-row {
          display: flex;
          flex-wrap: wrap;
        }
        .equal-height-row > [class*='col-'] {
          display: flex;
          flex-direction: column;
        }
        .equal-height-row .card {
          flex: 1;
        }
      `}</style>
    </div>
  );
};

export default OverviewTab;
